/**
 * Knowledge search API client.
 * All requests include auth token and are org-scoped server-side.
 */
import { authFetch, API_V1 } from '../constants';

export interface SearchResult {
  id: number;
  content_type: string;
  source_id: number;
  source_table: string;
  text: string;
  similarity: number;
  composite_score: number;
  entity_code: string | null;
  department: string | null;
  exception_type: string | null;
  outcome: string | null;
  created_at: string | null;
}

export interface SearchResponse {
  query: string;
  count: number;
  results: SearchResult[];
}

export async function searchKnowledge(
  query: string,
  options?: {
    contentTypes?: string[];
    entityCode?: string;
    department?: string;
    exceptionType?: string;
    topK?: number;
  }
): Promise<SearchResponse> {
  const params = new URLSearchParams({ q: query });

  if (options?.contentTypes?.length) {
    params.set('content_types', options.contentTypes.join(','));
  }
  if (options?.entityCode) params.set('entity_code', options.entityCode);
  if (options?.department) params.set('department', options.department);
  if (options?.exceptionType) params.set('exception_type', options.exceptionType);
  if (options?.topK) params.set('top_k', options.topK.toString());

  const response = await authFetch(`${API_V1}/knowledge/search?${params}`);

  if (!response.ok) {
    throw new Error(`Search failed: ${response.status}`);
  }

  return response.json();
}
